import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../_services/app.service';
import { CommonService } from '../shared/services/commen/commen.services';

@Component({
  selector: 'app-download-pittie-mail-reports',
  templateUrl: './download-pittie-mail-reports.component.html',
  styleUrls: ['./download-pittie-mail-reports.component.scss']
})
// Added by priya - 13/11/2025
export class DownloadPittieMailReportsComponent implements OnInit {

  Type: any = '';
  Duration: any = '';
  ReportData: any = [];
  ReportHeader: any = [];
  Title: any = '';

  constructor(
    private _appService: appService,
    private toastr: ToastrService,
    private _activatedRoute: ActivatedRoute,
    private commonService: CommonService,
  ) { }

  ngOnInit() {
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      this.Type = params["Type"];
      this.Duration = params["Duration"];
      if(this.Type !== '' && this.Type !== null && this.Type !== undefined){
        setTimeout(() => {
          this.GetReports(this.Type, this.Duration)
        }, 300);
      }
    });
  }

  GetReports(Type, Duration){
    let apiName = '';
    if (Type == 'IndentListForPendingTrips'){
      apiName = 'GetIndentListForPendingTrips';
      this.Title = 'Indent List For Pending Trips'
    } else if (Type == 'IndentListWithoutPOD'){
      apiName = 'GetIndentListWithoutPod';
      this.Title = 'Indent List Without POD'
    } else if (Type == 'LowVehicleUtilization'){
      apiName = 'GetLowVehicleUtilization';
      this.Title = 'Low Vehicle Utilization'
    } else {
      this.toastr.error("Report Type is missing", 'error');
      return;
    }
    this._appService.GetByOneParam("OrdersByVehicle", apiName, Duration).subscribe(
      (response) => {
        let rawData = response.Table;
        const excludeColumns = ["bodyVar", "filename", "recipients", "subjectVar"];
        this.ReportData = rawData.map(item => {
          let filteredItem: any = {};
          Object.keys(item).forEach(key => {
            if (!excludeColumns.includes(key)) {
              filteredItem[key] = item[key];
            }
          });
          return filteredItem;
        });
        if (this.ReportData.length > 0) {
          this.ReportHeader = Object.keys(this.ReportData[0]);
        }

        // this.ReportData = response.Table[0];
        // let i = 0;
        // this.ReportData.forEach(function (value, prop, obj) {
        //   if (i == 0) {
        //     this.ReportHeader = Object.getOwnPropertyNames(value);
        //   }
        //   i++;
        // });
      },
      (err) => {
        this.toastr.error("Error in Report", "error");
      }
    );
  }

  DownloadWeekly(){
    let apiName = '';
    if (this.Type == 'IndentListForPendingTrips') {
      apiName = 'DownloadIndentListForPendingTrips';
    } else if (this.Type == 'IndentListWithoutPOD') {
      apiName = 'DownloadIndentListWithoutPod';
    } else if (this.Type == 'LowVehicleUtilization') {
      apiName = 'DownloadLowVehicleUtilization';
    } else {
      this.toastr.error("Report Type is missing", 'error');
      return;
    }
    this._appService.GetByOneParam("OrdersByVehicle", apiName, 'Weekly').subscribe(
      (response) => {
        if (Array.isArray(response)) {
          response.forEach(file => this.DownloadFile(file));
        } else {
          this.DownloadFile(response);
        }
      },
      (err) => {
        this.toastr.error("Error in downloading", "error");
      }
    );
  }

  DownloadDaily() {
    let apiName = '';
    if (this.Type == 'IndentListForPendingTrips') {
      apiName = 'DownloadIndentListForPendingTrips';
    } else if (this.Type == 'IndentListWithoutPOD') {
      apiName = 'DownloadIndentListWithoutPod';
    } else if (this.Type == 'LowVehicleUtilization') {
      apiName = 'DownloadLowVehicleUtilization';
    } else {
      this.toastr.error("Report Type is missing", 'error');
      return;
    }
    this._appService.GetByOneParam("OrdersByVehicle", apiName, 'Daily').subscribe(
      (response) => {
        if (Array.isArray(response)) {
          response.forEach(file => this.DownloadFile(file));
        } else {
          this.DownloadFile(response);
        }
      },
      (err) => {
        this.toastr.error("Error in downloading", "error");
      }
    );
  }

  DownloadHourly(){
    let apiName = '';
    if (this.Type == 'IndentListForPendingTrips') {
      apiName = 'DownloadIndentListForPendingTrips';
    } else if (this.Type == 'IndentListWithoutPOD') {
      apiName = 'DownloadIndentListWithoutPod';
    } else if (this.Type == 'LowVehicleUtilization') {
      apiName = 'DownloadLowVehicleUtilization';
    } else {
      this.toastr.error("Report Type is missing", 'error');
      return;
    }
    this._appService.GetByOneParam("OrdersByVehicle", apiName, '3HR').subscribe(
      (response) => {
        if (Array.isArray(response)) {
          response.forEach(file => this.DownloadFile(file));
        } else {
          this.DownloadFile(response);
        }
      },
      (err) => {
        this.toastr.error("Error in downloading", "error");
      }
    );
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(FileContent.Content, FileContent.ContentType);
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileTyreReport").attr('href', url);
    $("#DownLoadFileTyreReport").attr('download', FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileTyreReport") as HTMLElement;
    element.attributes
    element.click();
  }

}
